import _ from 'lodash';
import React, { Fragment } from 'react';
import { observer } from 'mobx-react';

import LibraryItem from './library-item';

export default observer(({ member }) => {

	const activeSubscriptions = member.subscribedTo.filter(s => s.active !== false);

	if (_.isEmpty(activeSubscriptions)) {

		return (
			<em>No New Releases</em>
		);
	}

	return (
		<Fragment>
			<h4 className="subheader">
				{ member.firstNamePlural } New Releases
			</h4>

			{
				//TODO: Filter out the song list based on new-release availability in database.
				[activeSubscriptions[0]].map(({ artistID }) => (
					<LibraryItem key={ artistID } artistID={ artistID } />
				))
			}
		</Fragment>
	);
});
